import { Theme, createStyles, makeStyles, styled } from '@material-ui/core/styles';
import { COLORS } from 'shared/constants/COLORS';
const {
  PLAIN_TEXT,
  DEFAULT_SWITCH_THUMB,
  LIGHT_SLIDER_THUMB,
  LIGHT_DEFAULT_SWITCH_THUMB,
  PRIMARY_SLIDER_THUMB,
  PRIMARY_SLIDER_TRACK,
} = COLORS;

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      padding: 0,
    },
    switchContent: {
      display: 'flex',
      color: PLAIN_TEXT,
      cursor: 'pointer',
      textDecoration: 'none',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& label': {
        marginRight: '0px',
        marginLeft: '0px',
      },
    },
    disabled: {
      '& .MuiSwitch-thumb': {
        background: `${DEFAULT_SWITCH_THUMB} !important`,
      },
    },
    switchComp: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      height: '16px',
      width: '30px',
      background: LIGHT_SLIDER_THUMB,
      borderRadius: '4px',
      '& > *': {
        height: '9px',
        width: '2px',
        borderRadius: '4px',
        background: DEFAULT_SWITCH_THUMB,
      },
      '& > *:not(:last-child)': {
        marginRight: '2px !important',
      },
    },

    customSwitch: {
      width: '70px',
      height: '36px',
      padding: 7,
      '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        top: '9px',
        transform: 'translateX(29px)',
        '&.Mui-checked': {
          color: PLAIN_TEXT,
          transform: 'translateX(9px)',
          '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor:
              theme.palette.type === 'dark'
                ? `${DEFAULT_SWITCH_THUMB} !important`
                : `${LIGHT_DEFAULT_SWITCH_THUMB} !important`,
          },
        },
      },

      '& .MuiSwitch-thumb': {
        background: PRIMARY_SLIDER_THUMB,

        width: '30px',
        height: '16px',
        borderRadius: '5px',
        '&:before': {
          content: "''",
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
        },
      },
      '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: PRIMARY_SLIDER_TRACK,
        borderRadius: '5px',
      },
    },
  });
});
